import { useEffect, useMemo, useState } from "react";
import { configureObjectTypesWithFiltersForTableUnderMap } from "./tableUnderMapFunctions";

type UseTableUnderMapFiltersArgs = {
    menuItem: any;
    baseFiltersExpressions?: Record<string, string> | null | undefined;
    forcedFiltersExpressions?: Record<string, string> | null | undefined;
    appliedFilters?: any;
    defaultObjectType?: string;
};

export function useTableUnderMapFilters({
    menuItem,
    baseFiltersExpressions,
    forcedFiltersExpressions,
    appliedFilters,
    defaultObjectType,
}: UseTableUnderMapFiltersArgs) {
    const [objectTypes, setObjectTypes] = useState<string | string[] | undefined>();
    const [tableFilters, setTableFilters] = useState<Record<string, string>>({});

    // Сливаем null/undefined в пустой объект, чтобы ниже не городить ?? {}
    const base = useMemo(() => baseFiltersExpressions ?? {}, [baseFiltersExpressions]);
    const forced = useMemo(() => forcedFiltersExpressions ?? {}, [forcedFiltersExpressions]);

    useEffect(() => {
        const result = configureObjectTypesWithFiltersForTableUnderMap(
            menuItem,
            appliedFilters,
            base,
            forced
        );

        if (result) {
            const { objectTypes, tableFilters } = result as any;
            setObjectTypes(objectTypes);
            setTableFilters(tableFilters);
        } else {
            // Фолбек: если конфиг слоёв не дал типов — используем defaultObjectType (если указан)
            const parts = Object.values({ ...base, ...forced }).filter(Boolean) as string[];
            if (defaultObjectType) {
                setObjectTypes(defaultObjectType);
                setTableFilters(parts.length ? { [defaultObjectType]: parts.join(' and ') } : { [defaultObjectType]: '' });
            } else {
                setObjectTypes(undefined);
                setTableFilters(parts.length ? { "": parts.join(' and ') } : {});
            }
        }
    }, [menuItem, base, forced, appliedFilters, defaultObjectType]);

    return { objectTypes, tableFilters } as const;
}


